<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
    href: String,
    as: String,
});
</script>

<template>
    <div>
        <button
            v-if="as == 'button'"
            type="submit"
            class="block w-full px-4 py-2 text-left text-sm font-normal leading-5 text-gray-700 transition hover:bg-gray-100 hover:no-underline focus:bg-gray-100 focus:outline-none"
        >
            <slot />
        </button>

        <a
            v-else-if="as == 'a'"
            :href="href"
            class="block px-4 py-2 text-sm font-normal leading-5 text-gray-700 transition hover:bg-gray-100 hover:no-underline focus:bg-gray-100 focus:outline-none"
        >
            <slot />
        </a>

        <Link
            v-else
            :href="href"
            class="block px-4 py-2 text-sm font-normal leading-5 text-gray-700 transition visited:text-gray-700 hover:bg-gray-100 hover:no-underline focus:bg-gray-100 focus:outline-none"
        >
            <slot />
        </Link>
    </div>
</template>
